import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=28fc92be&scoped=true"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js"
import style0 from "./SysGatewayRouteList.vue?vue&type=style&index=0&id=28fc92be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc92be",
  null
  
)

export default component.exports